import 'vuetify/dist/vuetify.css'

import Vue from 'vue'
import App from './app/components/main/App.vue'
import router from './router'
import store from './vuex'
import http from './http'
import Vuetify from 'vuetify'
import VueSweetAlert from 'vue-sweetalert'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import VueScrollTo from 'vue-scrollto'
import VueCookie from 'vue-cookie'
import VueClipboard from 'vue-clipboard2'
import HighchartsVue from 'highcharts-vue'
import VueFacebookPixel from 'vue-facebook-pixel'

// import Tawk from 'vue-tawk'

import './registerServiceWorker'
import './app/filters'

Vue.use(http, {router, store})
Vue.use(Vuetify, {
  theme: {
    primary: '#465e54',
    secondary: '#F4863F'
  }
})
Vue.use(VueSweetAlert)
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueScrollTo)
Vue.use(HighchartsVue)
Vue.use(VueCookie)
Vue.use(VueClipboard)
Vue.use(VueFacebookPixel)
/* Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/5e73aca18d24fc226588b421/default'
}) */

/**
 * Cria a instância do vue
 */
/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js